var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('app-layout-air-later-life-header'),_c('v-main',{style:({ 'padding-top': _vm.$vuetify.breakpoint.smAndDown ? '100px' : '140px' })},[_c('app')],1),_c('app-layout-air-later-life-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }